import { useTranslation } from "react-i18next";
import { Pencil, ChevronDown } from "@digital-twins/design-system/icons";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type { CreativeCharacterEditActionProps } from "@/types/creative-library";

/** Membership, never image names, determines which character gallery is edited. */
export function CreativeCharacterEditAction({
  item,
  subjects,
  onOpen,
  onAssign,
  disabled,
}: CreativeCharacterEditActionProps) {
  const { t } = useTranslation("app");
  const linked = subjects.filter(
    (subject) =>
      subject.brandToken === item.brandToken &&
      subject.referenceTokens.includes(item.token),
  );
  const trigger = (
    <Button
      variant="ghost"
      disabled={disabled}
      data-testid="creative-edit-character"
      onClick={
        linked.length < 2
          ? () => (linked.length === 1 ? onOpen(linked[0]) : onAssign())
          : undefined
      }
    >
      <Pencil className="h-4 w-4" />
      {t("creativeLibrary.editCharacter")}
      {linked.length > 1 && <ChevronDown className="h-4 w-4" />}
    </Button>
  );
  return linked.length < 2 ? (
    trigger
  ) : (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent>
        {linked.map((subject) => (
          <DropdownMenuItem
            key={subject.token}
            onSelect={() => onOpen(subject)}
          >
            {subject.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
